export default __webpack_public_path__ + "static/media/1301.3a0f5dc1.png";